function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#000105;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,0h24v24H0V0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12,2.9c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S17,2.9,12,2.9z M12,18.9c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S15.9,18.9,12,18.9z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  y: 8.9,
  width: 2,
  height: 6
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 8.9,
  width: 2,
  height: 6
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 7.7,
  transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 24.905 0.905)",
  className: "st1",
  width: 2,
  height: 10.5
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 5.8,
  transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 21.7175 -2.2825)",
  className: "st1",
  width: 2,
  height: 7.8
});

var Svg2 = function Svg2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2.ce21484f.svg";
export { ForwardRef as ReactComponent };